import Badge from '@atoms/Badge';
import { type PurchasePlanSettings } from '@components/PricingPlans';
import { usePurchasePlan } from '@lib/hooks/usePlanSettings';
import { useTeamsData } from '@lib/hooks/useTeamsData';

type ProBadgeProps = {
  entitlement: keyof PurchasePlanSettings;
  className?: string;
}

export default function ProBadge({ entitlement, className }: ProBadgeProps) {
  const ownerId = useTeamsData((s) => s.currentTeamBillingAccountOwnerID);
  const { name, settings } = usePurchasePlan(ownerId);

  if (!name || settings[entitlement] === true) return null;

  return <Badge className={`ml-auto uppercase ${className || ''}`}>Pro</Badge>;
}
